var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.startmarketingprompt)?_c('img',{style:({top:_vm.currentTop + 'px'}),attrs:{"id":"marketingPromptImg","src":"images/try_us_triangle.png"},on:{"click":function($event){return _vm.openMarketing($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }